module.exports = __webpack_public_path__ + "static/media/San Marino.536a056a.png";